import TmrBaseResource from './TmrBaseResource'

export default class TransferToZone extends TmrBaseResource {
  static endpoint = '/transfersToZone'
}
